import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'items.item-submit-error-modal.title',
    defaultMessage: 'Uh oh! We were unable to submit your item',
  },
  description: {
    id: 'items.item-submit-error-modal.description',
    defaultMessage:
      'This can happen due to temporary technical difficulties. Please contact us with the following info to ensure your item is submitted:',
  },
  addPricing: {
    id: 'items.item-submit-error-modal.add-pricing',
    defaultMessage: 'Hi, I\u2019d like to add pricing for my menu item:',
  },
  itemName: {
    id: 'items.item-submit-error-modal.item-name',
    defaultMessage: 'Item name: <strong>{itemName}</strong>',
  },
  menuPrice: {
    id: 'items.item-submit-error-modal.menu-price',
    defaultMessage: 'Menu price: <strong>{menuPrice}</strong>',
  },
  menuLink: {
    id: 'items.item-submit-error-modal.menu-link',
    defaultMessage: 'Menu link: <strong>{linkToMenu}</strong>',
  },
  copy: {
    id: 'items.item-submit-error-modal.copy',
    defaultMessage: 'Copy text',
  },
  contactUs: {
    id: 'items.item-submit-error-modal.contact-us',
    defaultMessage: 'Contact us',
  },
  addPricingTemplate: {
    id: 'items.item-submit-error-modal.add-pricing-template',
    defaultMessage: `Hi, I\u2019d like to add pricing for my menu item:
    Item name: {itemName}
    Menu price: {menuPrice}
    Menu link: {linkToMenu}`,
  },
});
